<template>
  <warehouse-mobile v-if="useMobileWarehouse" />
  <warehouse-desktop v-else-if="useDesktopWarehouse" />
  <warehouse-legacy v-else :show-new-view="useLegacyDesktop" @new-view="useNewView" />
</template>

<script>
import WarehouseDesktop from "@/components/warehouse-shell/WarehouseDesktop.vue";
import WarehouseLegacy from "@/components/warehouse-shell/WarehouseLegacy.vue";
import WarehouseMobile from "@/components/warehouse-shell/mobile/WarehouseMobile.vue";
import { LEGACY_UI_VALUE } from "@/components/warehouse-shell/warehouseQuery";

/**
 * Magacin (/warehouse): gornja navigacija i zajednička traka filtera kao u izveštajima (ljuska warehouse-shell);
 * na telefonu početna sa listom tabova. ?ui=stari vraća staru stranicu (tabovi).
 */
export default {
  name: "WarehousePage",
  components: {
    WarehouseDesktop,
    WarehouseLegacy,
    WarehouseMobile,
  },
  computed: {
    /** ?ui=stari vraća staru stranicu (tabovi) dok se novi izgled ne potvrdi. */
    useLegacyDesktop() {
      return !this.device.isMobile && this.$route.query.ui === LEGACY_UI_VALUE;
    },
    /** Telefon (širina do 600 px): početna sa listom tabova i tabovi u kartičnom prikazu. */
    useMobileWarehouse() {
      return this.device.isMobile && this.$route.query.ui !== LEGACY_UI_VALUE;
    },
    /** Računar i tablet (širina iznad 600 px): gornja navigacija i zajednička traka filtera. */
    useDesktopWarehouse() {
      return !this.device.isMobile && !this.useLegacyDesktop;
    },
  },
  methods: {
    /** Vraća novi izgled (briše ?ui=stari). */
    useNewView() {
      const query = { ...this.$route.query };
      delete query.ui;
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
